import Layout from "../components/utils/layout";
import React from "react";
import Formatters from "../components/utils/formatters";

const OperationsDashboard = () => {
    const screenId="OperationsDashboard"
    const formatters = Formatters()
    const charts = {
                manual_kyc_checks                       :{
                    specialFormatters : {
                        time:formatters.isoDateTime,
                        level:formatters.int,
                        score:formatters.int,
                        account_id:formatters.account_id_link
                    }
                },
                kyc_duplicates                          :{
                    specialFormatters : {
                        order_date:formatters.isoDateTime,
                        order_id:formatters.int
                    }
                },
                monitor_transactions_over_40            :{
                    specialFormatters : {
                        txn_date:formatters.isoDate,
                        billing_amount:formatters.int,
                        available_balance:formatters.int,
                        owner_id:formatters.account_id_link
                    }
                },
                fraud_monitoring                        :{
                    specialFormatters : {
                        date:formatters.isoDate,
                        last_tx_timestamp:formatters.isoDateTime,
                        flag_category:formatters.long_description,
                        source:formatters.long_description,
                        description:formatters.long_description,
                        parent_id:formatters.account_id_link,
                        load_amount:formatters.int,
                        atm_amount:formatters.int,
                        debit_card_updates:formatters.int,
                        times_appeared_in_last_30d:formatters.int
                    }
                },
                fraud_monitoring_high_risk              :{
                    specialFormatters : {
                        date:formatters.isoDate,
                        last_tx_timestamp:formatters.isoDateTime,
                        flag_category:formatters.long_description,
                        source:formatters.long_description,
                        description:formatters.long_description,
                        parent_id:formatters.account_id_link,
                        load_amount:formatters.int,
                        atm_amount:formatters.int,
                        debit_card_updates:formatters.int,
                        times_appeared_in_last_30d:formatters.int
                    }
                },
                repeat_high_fraud_risks                  :{
                    specialFormatters : {
                        date:formatters.isoDate,
                        last_tx_timestamp:formatters.isoDateTime,
                        flag_category:formatters.long_description,
                        source:formatters.long_description,
                        description:formatters.long_description,
                        parent_id:formatters.account_id_link,
                        load_amount:formatters.int,
                        atm_amount:formatters.int,
                        debit_card_updates:formatters.int,
                        times_appeared_in_last_30d:formatters.int
                    }
                },
                recent_chargebacks                      :{
                    specialFormatters : {
                        date_trunc: formatters.isoDate,
                        count: formatters.int
                    }
                },
                offline_transactions                    :{
                    specialFormatters : {
                        owner_id:formatters.account_id_link,
                        card_id:formatters.card_id_link,
                        date_trunc:formatters.isoDate,
                        acquirer_id:formatters.int,
                        transaction_description:formatters.long_description,
                        available_balance:formatters.int
                    }
                },
                safe_report                             :{
                    specialFormatters : {
                        date:formatters.isoDate
                    }
                },
                address_and_card_updates_within_7_days  :{
                    specialFormatters : {
                        account_id:formatters.account_id_link,
                        created:formatters.isoDateTime,
                        latest_add_change:formatters.isoDateTime,
                        add_updates:formatters.int,
                        attempts:formatters.int,
                        count:formatters.int
                    }
                },
                failed_logins :{},
                card_statement: {
                    source: "redshift"
                }

    }
    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default OperationsDashboard
